// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { contextIdentifierPlugin } from '@atlaskit/editor-plugin-context-identifier';
export type {
	ContextIdentifierPlugin,
	ContextIdentifierConfiguration,
	PluginConfiguration,
} from '@atlaskit/editor-plugin-context-identifier';
